// @flow

import { Base, Svg } from '@gandi/ui';

import styles from './CommercialPoint.scss';

export type Props = {
  children: string | React.MixedElement,
  iconName: 'arrowRight' | 'checkmark',
};

export function CommercialPoint({
  children,
  iconName,
}: Props): React.MixedElement {
  return (
    <Base
      tagName="li"
      className={styles.listItem}
      flex
      flexAlignItemsCenter
      flexBasis0
    >
      <Svg theme="white" name={iconName} size="3x" />
      <p>{children}</p>
    </Base>
  );
}
